"use client"

import ROICTree from "./roic-tree"

const ROICTreeVisualizer = ({companies}) => {
  const transformRoicData = (data) => {
    const length = data.sec_code.length;
    const result = [];
  
    for (let i = 0; i < length; i++) {
      const entry = { id: i + 1, name: data.company_name[i], data: {} };
  
      for (const key in data) {
        if (["sec_code", "company_name"].includes(key)) continue; // nameとして処理済み
        entry.data[key] = data[key][i];
      }
  
      result.push(entry);
    }
  
    return result;
  };
  
  return (
    <div className="w-full">
      <div className="bg-white p-4 rounded-lg border overflow-x-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">ROICツリー</h2>
          <div className="text-sm text-gray-500">単位: 比率（%）</div>
        </div>
        <ROICTree companies={transformRoicData(companies)} />
      </div>
    </div>
  )
}

export default ROICTreeVisualizer
